import React from 'react';
import { View, Text } from 'react-native';
import { CHAT_UNREAD_BADGE_MAX } from '../constants';
import { useUnreadChannelsCount } from '../hooks/useUnreadChannelsCount';
import { ChatTabBarIcon } from './icons';

export const ChatTabIcon = ({ color, size, focused }: { color: string; size: number; focused: boolean }): React.ReactElement => {
    const unreadCount = useUnreadChannelsCount();

    return (
        <View>
            <ChatTabBarIcon focused={focused} size={size} color={color} />
            {unreadCount > 0 && (
                <View className="absolute -top-2 -right-[17px] w-[34px] h-[24px] rounded-[999px] border-2 border-white bg-secondary-600 items-center justify-center">
                    <Text className="text-white text-sm font-bold leading-none">
                        {unreadCount > CHAT_UNREAD_BADGE_MAX ? `${CHAT_UNREAD_BADGE_MAX}+` : unreadCount}
                    </Text>
                </View>
            )}
        </View>
    );
};
